/**
 * Unicode characters for various quotation marks.
 * Source: https://www.compart.com/en/unicode/search?q=quotation#characters
 *
 * @type {Unicode}
 */
export const unicodes = {
  LeftPointingDoubleAngleQuotationMark: '\u00AB',
  RightPointingDoubleAngleQuotationMark: '\u00BB',
  LeftDoubleQuotationMark: '\u201C',
  RightDoubleQuotationMark: '\u201D',
  DoubleLow9QuotationMark: '\u201E',
  DoubleHigh9QuotationMark: '\u201F',
  HorizontalEllipsis: '\u2026',
};

/**
 * Description placeholder
 *
 * @type {Record<import("~/types/providers").LanguagesShort, {LeftQuotationMark: UnicodeValue, RightQuotationMark: UnicodeValue}>}
 */
export const quotationMarks = {
  de: {
    LeftQuotationMark: unicodes.DoubleLow9QuotationMark,
    RightQuotationMark: unicodes.DoubleHigh9QuotationMark,
  },
  en: {
    LeftQuotationMark: unicodes.LeftDoubleQuotationMark,
    RightQuotationMark: unicodes.RightDoubleQuotationMark,
  },
  es: {
    LeftQuotationMark: unicodes.LeftPointingDoubleAngleQuotationMark,
    RightQuotationMark: unicodes.RightPointingDoubleAngleQuotationMark,
  },
};

/**
 * @param {Object} params
 * @param {string} params.quote
 * @param {import('~/types/providers').LanguagesShort} params.language
 * @returns {string}
 */
export const addQuotes = ({ quote, language }) => {
  const lang = language in quotationMarks ? language : 'en';
  const { LeftQuotationMark, RightQuotationMark } = quotationMarks[lang];
  return `${LeftQuotationMark}${quote}${RightQuotationMark}`;
};
